<script setup lang="ts">
import { useMobileView } from '@metapic-apps/shared'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useGetNotificationStatuses } from '@/api/notifications.api'
import CampaignOverviewContent from '@/components/CampaignOverview/CampaignOverviewContent.vue'
import { DrawerComponent } from '@/ui-library'

const isOpen = defineModel<boolean>('modelValue', { default: false })
const emits = defineEmits(['onDelete', 'onRefresh'])
const route = useRoute()
const router = useRouter()

const campaignId = computed(() => Number(route.query.campaignId as unknown as string))
const campaignIds = computed(() => [campaignId.value])
const { notificationStatuses } = useGetNotificationStatuses(campaignIds)
const { isMobileView } = useMobileView()
const handleClose = async () => {
  await router.push({ query: { ...route.query, campaignId: undefined } })
  isOpen.value = false
}
</script>
<template>
  <DrawerComponent
    v-if="isOpen"
    v-model="isOpen"
    :size="isMobileView ? '100%' : '45%'"
    :is-resizable="!isMobileView"
    destroy-on-close
    @closed="handleClose"
  >
    <CampaignOverviewContent
      v-if="campaignId"
      :campaign-id="campaignId"
      :has-update="notificationStatuses.has(campaignId)"
      @on-refresh="emits('onRefresh')"
      @on-delete="emits('onDelete', campaignId)"
      @on-close="handleClose"
    />
  </DrawerComponent>
</template>
<style lang="scss" scoped></style>
